import { Box, Stack, styled } from '@mui/material';

export const ScrollableContent = styled(Box)(() => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  overflowX: 'hidden',
  position: 'relative',
}));

export const CommentsList = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

export const FooterContainer = styled(Box)(() => ({
  flexShrink: 0,
}));

export const AddCommentPlaceholder = styled(Stack, {
  shouldForwardProp: (prop) =>
    prop !== 'disabled' && prop !== 'accentMain' && prop !== 'accentLight',
})<{ disabled?: boolean; accentMain: string; accentLight: string }>(
  ({ disabled, accentMain, accentLight }) => ({
    padding: '0.75rem',
    width: '100%',
    borderRadius: '8px',
    border: disabled ? '0.5px solid #C2C3CE' : `0.5px solid ${accentMain}`,
    background: disabled ? '#EBEBEE' : accentLight,
    boxShadow: disabled ? '0 2px 4px 0 rgba(0, 0, 0, 0.08)' : `0 2px 4px 0 ${accentMain}33`,
    cursor: disabled ? 'default' : 'pointer',
  }),
);
